import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {MDBBtn} from "mdb-react-ui-kit";

const ExcelExport = ({ data, fileName }) => {
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(listDataToObjects(data));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tabelle1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        saveAs(blob, `${fileName}.xlsx`);
    };

    const listDataToObjects = (listData) => {
        if (listData.size === 0) {
            return [];
        }
        const newList = listData.slice(1).map(row => {
            return Object.fromEntries(row.map((value, index) => [listData[0][index], value]));
        });
        console.log(newList);
        return newList;
    }

    return (
        <MDBBtn className="btn" type="submit" onClick={exportToExcel}>
            <FontAwesomeIcon className='btn-icon' icon={faDownload} />
            XLSX herunterladen
        </MDBBtn>
    );
}

export default ExcelExport;